import { skipToken } from '@reduxjs/toolkit/query'
import { useEffect, useMemo } from 'react'
import { useGetDiningVenuesInfoQuery } from '../store'
import { useReservationsRoute } from './useReservationsRoute'
import { useVenue } from './useVenue'

export function useGroupOrCrossSellWidget() {
  const { urlKey, multiVenueReservationEnabled } = useVenue()
  const { venues, clearQueryParams } = useReservationsRoute()

  const venuesFromParam = useMemo(() => venues?.split(',') || [], [venues])
  const otherVenues = useMemo(() => venuesFromParam.filter(v => v !== urlKey), [urlKey, venuesFromParam])
  const hasCurrentVenueInParam = useMemo(() => venuesFromParam.includes(urlKey), [urlKey, venuesFromParam])
  const shouldFetchOtherVenuesInfo = useMemo(
    () => multiVenueReservationEnabled && (otherVenues?.length || 0) > 0,
    [multiVenueReservationEnabled, otherVenues?.length]
  )

  // no group nor cross-promotion widget -> venuesInfo is undefined
  // group widget -> venuesInfo.venues > 0 and current venue not in param
  // cross-promotion widget -> venuesInfo.venues > 0 and current venue not in param
  const {
    isError,
    isFetching: isFetchingVenuesInfo,
    data: venuesInfo,
  } = useGetDiningVenuesInfoQuery(shouldFetchOtherVenuesInfo ? { venueUrlKey: urlKey, venues: otherVenues.join(',') } : skipToken)

  // was added in GX-3473
  useEffect(() => {
    if (!multiVenueReservationEnabled && venues) {
      clearQueryParams('venues')
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const isGroupWidget = !!(
    shouldFetchOtherVenuesInfo &&
    !hasCurrentVenueInParam &&
    (isFetchingVenuesInfo || (!isError && (venuesInfo?.venues?.length || 0) > 0))
  )

  return { isGroupWidget, isCrossSellWidget: shouldFetchOtherVenuesInfo, isFetchingVenuesInfo, venuesInfo }
}
